<script>
export default {
	name: 'MasKargoDefaultLayout',
	expose: [],
	inheritAttrs: false,
};
</script>


<script setup>
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';
</script>


<template>
<div class="MasKargoDefaultLayout flex flex-col min-h-screen" data-layout="Default">
	<ExperienceFragment
		class="global-header-notification"
		xfPath="/content/experience-fragments/maskargo/$lang/site/header-notification/master"
	/>
	<div class="sticky-spacer h-$headerNotificationHeight"></div>

	<ExperienceFragment
		class="global-header"
		xfPath="/content/experience-fragments/maskargo/$lang/site/header/master"
	/>
	<div id="content"></div>
	<main>
		<slot></slot>
	</main>

	<ExperienceFragment
		class="global-footer"
		xfPath="/content/experience-fragments/maskargo/$lang/site/footer/master"
	/>
</div>
</template>

<style scoped lang="scss">
@use '~/styles/partials/_var.scss';
:slotted(.page) {
	min-height: 400px;
}
</style>